"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
/**Una tarjeta con material design. Los hijos del componente seran dibujados adentro de la tarjeta */
class Card extends React.Component {
    render() {
        return (React.createElement("div", { className: "alert alert-info" },
            this.props.Header &&
                React.createElement("strong", null,
                    this.props.Header,
                    " ",
                    " "),
            this.props.children));
    }
}
exports.Card = Card;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/card.js
// module id = 2203
// module chunks = 0